module.exports = __webpack_public_path__ + "media/img/event/interpreter-banner-abafdbc836ecb4a6f5ff8b117b6e0781.jpeg";